package com.hyperether.goodjob.scenes.landing

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.withStyle
import androidx.compose.ui.unit.toSize
import com.hyperether.goodjob.models.Plan
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.all_rights_reserved
import com.hyperether.goodjob.resources.and_we_will
import com.hyperether.goodjob.resources.effortless_efficiency
import com.hyperether.goodjob.resources.enter_your_email
import com.hyperether.goodjob.resources.free_hundred
import com.hyperether.goodjob.resources.ic_check_white
import com.hyperether.goodjob.resources.its
import com.hyperether.goodjob.resources.landing_img_dark
import com.hyperether.goodjob.resources.optimize_your
import com.hyperether.goodjob.resources.pricing
import com.hyperether.goodjob.resources.privacy_policy
import com.hyperether.goodjob.resources.terms_of_service
import com.hyperether.goodjob.resources.transform
import com.hyperether.goodjob.resources.transparent_flexible
import com.hyperether.goodjob.resources.whether
import com.hyperether.goodjob.scenes.components.RoundedTextFieldWithButton
import com.hyperether.goodjob.scenes.components.SubscriptionToggle
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.pricing.PricingPlansWeb
import com.hyperether.goodjob.theme.LandingPageBg
import com.hyperether.goodjob.theme.LandingPageMainTitle
import com.hyperether.goodjob.theme.LandingPageNavColor
import com.hyperether.goodjob.theme.LandingPageSmallTitle
import com.hyperether.goodjob.theme.LandingPageText
import com.hyperether.goodjob.util.WEB_SCREEN_SIZE_LIMIT
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.planner.util.verticalScrollbar
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun LandingPageWebView(
    selectedOption: MutableState<String>,
    containerSize: MutableState<Size>,
    plans: List<Plan>,
    enteredEmail: MutableState<String>,
    continueToRegister: () -> Unit,
    subscribeUser: () -> Unit,
    onOpenPdf: (String) -> Unit
) {
    val termsOfServiceFilePath = "GoodJob_Terms_Conditions.pdf"
    val privacyPolicyFilePath = "GoodJob_Privacy_Policy.pdf"
    val scrollState = rememberScrollState()
    Column(
        modifier = Modifier
            .fillMaxSize()
            .verticalScrollbar(scrollState)
            .verticalScroll(scrollState)
            .disableMouseDragScrollOnWeb()
            .background(LandingPageBg)
            .background(
                Brush.radialGradient(
                    colors = listOf(
                        Color.White.copy(alpha = 0.2f),
                        Color.Transparent
                    ),
                    center = Offset(
                        x = 0f,
                        y = containerSize.value.height / 3f
                    ),
                    radius = containerSize.value.width / 4f
                )
            )
            .onSizeChanged { size ->
                containerSize.value = size.toSize()
            },
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.SpaceBetween
    ) {
        WebContentHolder(
            modifier = Modifier
                .height(126.toScaleDp())
                .background(LandingPageNavColor)
        ) {
            LandingHeader(
                continueToRegister = continueToRegister
            )
        }

        Spacer(modifier = Modifier.height(92.toScaleDp()))

        WebContentHolder {
            Row(
                modifier = Modifier
                    .widthIn(max = WEB_SCREEN_SIZE_LIMIT)
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.Center
            ) {
                Column(
                    modifier = Modifier
                        .weight(1f)
                        .width(663.toScaleDp()),
                    verticalArrangement = Arrangement.Center,
                ) {
                    Text(
                        text = stringResource(Res.string.effortless_efficiency),
                        fontSize = 16.toScaleSp(),
                        lineHeight = 18.toScaleSp(),
                        color = LandingPageSmallTitle
                    )
                    Spacer(modifier = Modifier.height(4.toScaleDp()))
                    Text(
                        text = stringResource(Res.string.transform),
                        fontSize = 50.toScaleSp(),
                        fontWeight = FontWeight.SemiBold,
                        lineHeight = 62.toScaleSp(),
                        color = LandingPageMainTitle,
                        modifier = Modifier
                            .fillMaxWidth(),
                    )
                    Spacer(modifier = Modifier.height(12.toScaleDp()))
                    Text(
                        text = stringResource(Res.string.optimize_your),
                        fontSize = 18.toScaleSp(),
                        color = LandingPageText,
                        lineHeight = 30.toScaleSp(),
                        fontWeight = FontWeight.W400,
                    )
                    Spacer(modifier = Modifier.height(32.toScaleDp()))
                    RoundedTextFieldWithButton(
                        isMobileView = false,
                        input = enteredEmail,
                        placeHolder = stringResource(Res.string.enter_your_email),
                        modifier = Modifier
                            .width(610.toScaleDp())
                            .height(77.toScaleDp()),
                        onSubscribe = {
                            subscribeUser()
                        }
                    )
                    Spacer(modifier = Modifier.height(25.toScaleDp()))
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Image(
                            painter = painterResource(Res.drawable.ic_check_white),
                            contentDescription = "Feature icon",
                            modifier = Modifier
                                .size(22.toScaleDp())
                        )
                        Text(
                            text = buildAnnotatedString {
                                append(stringResource(Res.string.its))
                                withStyle(style = SpanStyle(fontWeight = FontWeight.Bold)) {
                                    append(stringResource(Res.string.free_hundred))
                                }
                                append(stringResource(Res.string.and_we_will))
                            },
                            color = LandingPageText,
                            fontSize = 16.toScaleSp(),
                            lineHeight = 18.toScaleSp(),
                            modifier = Modifier
                                .padding(start = 25.toScaleDp())
                        )
                    }
                }
                Spacer(modifier = Modifier.width(120.toScaleDp()))
                Image(
                    modifier = Modifier
                        .weight(1f)
                        .height(511.toScaleDp())
                        .width(457.toScaleDp()),
                    painter = painterResource(Res.drawable.landing_img_dark),
                    contentDescription = "Landing image"
                )
            }
        }

        Spacer(modifier = Modifier.height(120.toScaleDp()))

        WebContentHolder {
            Column(
                modifier = Modifier
                    .widthIn(max = WEB_SCREEN_SIZE_LIMIT)
                    .fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Text(
                    text = stringResource(Res.string.pricing),
                    fontSize = 18.toScaleSp(),
                    lineHeight = 20.toScaleSp(),
                    color = LandingPageSmallTitle,
                    textAlign = TextAlign.Center
                )
                Spacer(modifier = Modifier.height(4.toScaleDp()))

                // Pricing Section Title
                Text(
                    text = stringResource(Res.string.transparent_flexible),
                    fontSize = 50.toScaleSp(),
                    lineHeight = 62.toScaleSp(),
                    fontWeight = FontWeight.Bold,
                    textAlign = TextAlign.Center,
                    color = LandingPageMainTitle
                )
                Spacer(modifier = Modifier.height(12.toScaleDp()))
                Text(
                    text = stringResource(Res.string.whether),
                    fontSize = 18.toScaleSp(),
                    lineHeight = 30.toScaleSp(),
                    color = LandingPageText,
                    textAlign = TextAlign.Center
                )

                Spacer(modifier = Modifier.height(32.toScaleDp()))

                SubscriptionToggle(
                    isDark = true,
                    isMobile = false,
                    selectedOption = selectedOption.value,
                    onOptionSelected = {
                        selectedOption.value = it
                    }
                )

                // Pricing Cards Container
                val matchingPlans = plans.filter {
                    selectedOption.value.lowercase()
                        .startsWith(it.interval?.lowercase() ?: "unknown") && it.price != 0.0
                }.toMutableList()
                plans.find { it.price == 0.0 }?.let {
                    matchingPlans.add(0, it)
                }

                Spacer(modifier = Modifier.height(80.toScaleDp()))

                PricingPlansWeb(
                    planList = matchingPlans
                )
            }
        }
        Spacer(modifier = Modifier.height(90.toScaleDp()))

        WebContentHolder(
            modifier = Modifier
                .background(LandingPageNavColor)
                .height(48.toScaleDp())
        ) {
            Row(
                modifier = Modifier
                    .widthIn(max = WEB_SCREEN_SIZE_LIMIT)
                    .fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Text(
                    text = stringResource(Res.string.all_rights_reserved),
                    fontSize = 15.toScaleSp(),
                    lineHeight = 18.toScaleSp(),
                    color = LandingPageMainTitle,
                    fontWeight = FontWeight.W400,
                    textAlign = TextAlign.End,
                    modifier = Modifier.weight(3f)
                )
                DisableSelection {
                    Text(
                        text = stringResource(Res.string.privacy_policy),
                        fontSize = 15.toScaleSp(),
                        lineHeight = 18.toScaleSp(),
                        color = LandingPageMainTitle,
                        textAlign = TextAlign.End,
                        fontWeight = FontWeight.W900,
                        modifier = Modifier.weight(1f).clickableWithPointer {
                            onOpenPdf(privacyPolicyFilePath)
                        }
                    )
                }
                DisableSelection {
                    Text(
                        text = stringResource(Res.string.terms_of_service),
                        fontSize = 15.toScaleSp(),
                        lineHeight = 18.toScaleSp(),
                        color = LandingPageMainTitle,
                        textAlign = TextAlign.End,
                        fontWeight = FontWeight.W900,
                        modifier = Modifier
                            .weight(1f)
                            .padding(end = 20.toScaleDp())
                            .clickableWithPointer {
                                onOpenPdf(termsOfServiceFilePath)
                            }
                    )
                }
            }
        }
    }
}

@Composable
fun WebContentHolder(
    modifier: Modifier = Modifier,
    content: @Composable BoxScope.() -> Unit
) {
    Box(
        modifier = modifier
            .fillMaxWidth()
            .padding(horizontal = 100.toScaleDp()),
        contentAlignment = Alignment.Center
    ) {
        content()
    }
}